import { render, staticRenderFns } from "./eval-detail-6.vue?vue&type=template&id=08cc6a44"
import script from "./eval-detail-6.vue?vue&type=script&lang=js"
export * from "./eval-detail-6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports